export const AUTH_INTERCEPTOR_NAMESPACE_HEADER = 'X-Auth-Interceptor-Namespace';
